import React from 'react';
import {reduxForm} from 'redux-form';
import {validateRequiredFields} from '../../utils/form';

import Button from '../button';
import FormField from '../form/form-field';
import Alert from '../alert';
import DateField from '../form/date-field';
import BaseForm from '../form/base-form';
import LocalizedStrings from '../../localization/strings';

const fields = [
    'id',
    'name',
    'isFree',
    'stageId',
    'code',
    'is_team_distance',
    'prices[].id',
    'prices[].price',
    'prices[].children_price',
    'prices[].older_price',
    'prices[].price_until_date',
    'max_age_restriction',
    'order'
];

function validate(values) {
    let errors = {
        _error: null
    };
    errors = validateRequiredFields(values, ['name', 'code'], errors);

    errors.prices = values.prices.map(price => {
        return validateRequiredFields(price, [
            'price', 'price_until_date', 'older_price', 'children_price'
        ], {});
    });
    console.log(errors.prices);
    return errors;
}

const PRICING_CONFIG = window.CARE_CONFIG.pricing;
class DistanceForm extends BaseForm {

    componentDidMount() {
        setTimeout(() => this.refs.name.focus());
    }

    preSubmit(values){
       return this.submit({
           ...values,
           max_age_restriction: values.max_age_restriction || null
       });
    }

    render() {
        const {
            submitting,
            errors,
            error,
            handleSubmit,
            fields: {
                name,
                isFree,
                prices,
                code,
                order,
                is_team_distance,
                max_age_restriction
            }
        } = this.props;

        const labelChildrenPrice = PRICING_CONFIG.customGroups? `${LocalizedStrings.age} <= ${PRICING_CONFIG.ageGroups.children}` : LocalizedStrings.childrenPrice
        const labelOlderPrice = PRICING_CONFIG.customGroups? `${LocalizedStrings.age} >= ${PRICING_CONFIG.ageGroups.older}` : LocalizedStrings.olderPrice;
        const labelPrice = PRICING_CONFIG.customGroups? `${PRICING_CONFIG.ageGroups.children} < ${LocalizedStrings.age} < ${PRICING_CONFIG.ageGroups.older}` : LocalizedStrings.price;

        return (
            <div className="distance-form">
                <form onSubmit={handleSubmit(this.preSubmit.bind(this))}>
                    {error && <Alert type="error">{error}</Alert>}
                    <FormField label={LocalizedStrings.title} name="name" field={name}>
                        <input ref="name" className="border-full larger" placeholder={LocalizedStrings.title} type="text" {...name}/>
                    </FormField>
                    <FormField label={LocalizedStrings.code} name="code" field={code} helperText={LocalizedStrings.codeHelperText}>
                        <input ref="code" className="border-full larger" placeholder={LocalizedStrings.code} type="text" {...code}/>
                    </FormField>
                    <FormField label={LocalizedStrings.order} name="order" field={order}>
                        <input ref="link" className="border-full larger" placeholder={LocalizedStrings.order} type="number" {...order}/>
                    </FormField>
                    <FormField label={LocalizedStrings.isFree} name="isFree" field={isFree} className="checkbox-field">
                        <input type="checkbox" {...isFree}/>
                    </FormField>
                    <FormField label={LocalizedStrings.isTeamDistance} name="isTeamDistance" field={is_team_distance} className="checkbox-field">
                        <input type="checkbox" {...is_team_distance}/>
                    </FormField>

                    <FormField label={LocalizedStrings.maxAgeRestriction} name="max_age_restriction" field={max_age_restriction}>
                        <input ref="max_age_restriction" className="border-full larger" placeholder={''} type="number" {...max_age_restriction}/>
                    </FormField>

                    {prices.map((price, index) => <div key={index} className="inline-fields">
                        <FormField label={labelPrice} name="price" field={price.price}>
                            <input ref="price" className="border-full larger" placeholder={labelPrice} type="number" {...price.price}/>
                        </FormField>

                        <FormField label={labelChildrenPrice} name="children_price" field={price.price}>
                            <input ref="children_price" className="border-full larger" placeholder={labelChildrenPrice} type="number" {...price.children_price}/>
                        </FormField>
                        <FormField label={labelOlderPrice} name="older_price" field={price.price}>
                            <input ref="children_price" className="border-full larger" placeholder={labelOlderPrice} type="number" {...price.older_price}/>
                        </FormField>
                        <FormField label={LocalizedStrings.dateUntil} name="price_until_date" field={price.price_until_date}>
                            <DateField {...price.price_until_date}></DateField>
                        </FormField>
                        <a className="btn btn-red" onClick={() => {
                            prices.removeField(index);
                        }}>
                            {LocalizedStrings.remove}
                        </a>
                    </div>)}
                    <a className="btn m-top-10 m-bot-10" onClick={() => {
                        prices.addField();
                    }}><i/> {LocalizedStrings.addPrice}
                    </a>
                    <div className="button-group">

                        <Button loading={submitting} submit={true} disabled={submitting || Object.keys(errors).length} type="primary">
                            {LocalizedStrings.submit}</Button>
                        <Button disabled={submitting} onClick={e => {
                            e.preventDefault();
                            this.props.cancel();
                        }} type="empty-primary pull-right">
                            {LocalizedStrings.cancel}</Button>
                    </div>
                </form>
            </div>
        )
    }
}

export default reduxForm({
    form: 'distance-form',
    fields,
    validate,
    destroyOnUnmount: true
}, state => ({initialValues: {
        isFree: false,
        is_team_distance: false,
        max_age_restriction: null,
    ...state.distance.distance
}}))(DistanceForm);



// WEBPACK FOOTER //
// ./src/js/components/stage/distance-form.js